<template>
  <v-container v-if="resume.workExperiences.length > 0" class="py-2">
    <BaseDivider :title="this.$t('work_experiences')" />
    <div v-for="(experience, i) in resume.workExperiences" :key="i">
      <template>
        <h4>{{ experience.title }} | {{ experience.company }}</h4>
        <p class="location">
          {{ experience.location }} |  {{ $t("from") }} {{ experience.startDate }} {{ $t("to") }}
          {{ experience.present ? $t("present"): experience.endDate }}
        </p>
        <p v-if="experience.description" class="description">
          {{ experience.description }}
        </p>
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "@/modules/create_resume/store/CreateResumeStore";
import BaseDivider from "./BaseDivider.vue";
export default {
    computed: {
        ...mapState(useCreateResumeStore, ["resume"]),
    },
    components: { BaseDivider }
};
</script>

<style scoped>
.location {
  opacity: 0.9;
  display: inline;
}
.description {
  opacity: 0.8;
}
</style>
